/** Entry point of the phase E hlcity package (Hualien city, Dongdamen Night Market, Pine Garden and Ji'an). Imported once from main.ts. */
import '../render/propsHlcity';
import './hlcity';
import { registerNpcs } from '../world/npcs';
import { NPCS_HLCITY } from '../world/npcsHlcity';

registerNpcs(NPCS_HLCITY);
